import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f16476"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "VAT Category name")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "VAT Category description")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "VAT Category Marker Image", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Marker Image Size", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "VAT Category 3D Asset", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "3D Asset Size", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_AssetManagerComponent = _resolveComponent("AssetManagerComponent")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref: "formRef",
      model: _ctx.categoryRef,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          ref: "name",
          name: "name"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_a_input, {
              type: "text",
              value: _ctx.categoryRef.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryRef.name) = $event)),
              placeholder: "VAT Category name",
              class: "ant-input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_a_form_item, { name: "description" }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_a_textarea, {
              value: _ctx.categoryRef.description,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.categoryRef.description) = $event)),
              placeholder: "VAT Category description",
              class: "ant-input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "image" }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("div", {
              class: "image",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.defineAsset('image'))),
              style: _normalizeStyle({
					backgroundImage: `url('${_ctx.categoryRef.image}')`,
					borderStyle: _ctx.categoryRef.image ? 'solid' : 'dashed'
				})
            }, [
              (!_ctx.categoryRef.image)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    class: "add-icon",
                    icon: "plus"
                  }))
                : _createCommentVNode("", true)
            ], 4)
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "imageSize" }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5,
            _createVNode(_component_a_input_number, {
              value: _ctx.categoryRef.imageSize,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.categoryRef.imageSize) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "asset" }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createElementVNode("div", {
              class: "image",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.defineAsset('asset'))),
              style: _normalizeStyle({
					borderStyle: _ctx.categoryRef.asset ? 'solid' : 'dashed'
				})
            }, [
              (!_ctx.categoryRef.asset)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    class: "add-icon",
                    icon: "plus"
                  }))
                : _createCommentVNode("", true),
              (_ctx.categoryRef.asset)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    style: {"font-size":"80px"},
                    icon: "cubes"
                  }))
                : _createCommentVNode("", true)
            ], 4)
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "imageSize" }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_a_input_number, {
              value: _ctx.categoryRef.assetSize,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.categoryRef.assetSize) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                type: "default",
                onClick: _ctx.onCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Submit")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showAssetManager,
      title: 'Assets',
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAssetManager = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssetManagerComponent, {
          onSetAsset: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setAsset($event)))
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}